import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

const parseMinutes = (time) => {
  if (!time || time === "") return 1440; // Treat empty as end of day
  const [hours, minutes] = time.split(":").map(Number);
  return hours * 60 + minutes;
};

const displayTime = (t, showMidnight) => {
  const isEmpty = t === undefined || t === "" || t === "00:00";
  if (isEmpty && !showMidnight) return "";
  return t || "00:00";
};

const StandardFormat = ({ panchangData, showMidnight = true }) => {
  return (
    <div>
      {panchangData.map((entry, index) => {
        const muhurtaData = Object.entries(entry.muhurta || {}).reduce((acc, [key, value]) => {
          const idx = key.match(/\d+/)?.[0];
          if (!idx) return acc;
          if (!acc[idx]) acc[idx] = {};
          acc[idx][key.includes("start") ? "start" : "end"] = value;
          return acc;
        }, {});

        Object.keys(muhurtaData).forEach(idx => {
          if (!muhurtaData[idx].end) muhurtaData[idx].end = "24:00";
        });

        return (
          <div key={index} className="card mb-4 shadow">
            <div className="card-header custom-card-header">
              <h2 className="h4">{entry.date}</h2>
              <h5>{entry.weekday}</h5>
            </div>
            <div className="card-body">
              <div className="col-md-12">
                <h5>Daily Panchang Details</h5>
                <pre style={{ fontFamily: "var(--font-mono)" }}>
                  {entry.nakshatra.map((item, i) => (
                    <div key={`nakshatra-${i}`}>
                      {(item[0] || "").padEnd(25, " ")}{displayTime(item[1], showMidnight)}
                    </div>
                  ))}
                  {entry.tithi.map((item, i) => (
                    <div key={`tithi-${i}`}>
                      {(item[0] || "").padEnd(25, " ")}{displayTime(item[1], showMidnight)}
                    </div>
                  ))}
                  {entry.yoga.map((item, i) => (
                    <div key={`yoga-${i}`}>
                      {(item[0] || "").padEnd(25, " ")}{displayTime(item[1], showMidnight)}
                    </div>
                  ))}
                  {entry.karana.map((item, i) => (
                    <div key={`karana-${i}`}>
                      {(item[0] || "").padEnd(25, " ")}{displayTime(item[1], showMidnight)}
                    </div>
                  ))}
                </pre>
              </div>
              <div className="favorable-box">
                {Object.keys(muhurtaData).length > 0 ? (
                  <>
                    <h5>Favorable Timings:</h5>
                    <ul>
                      {Object.entries(muhurtaData).map(([idx, { start, end }]) => (
                        <li key={idx}>
                          {displayTime(start, showMidnight)} - {end || "24:00"}
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <p className="no-favorable-timings">No favourable timings</p>
                )}
                <ul className="rashi-list-animated">
                  {entry.rashi
                    .filter(([name, time]) => time !== "00:00")
                    .filter(([name, time]) => {
                      const valueMinutes = parseMinutes(time);
                      return Object.values(muhurtaData).some(({ start, end }) => {
                        return parseMinutes(start) <= valueMinutes && valueMinutes <= parseMinutes(end);
                      });
                    })
                    .map(([name, time], i) => (
                      <li key={i} className="rashi-item-loop">
                        {name} - {time}
                      </li>
                    ))}
                </ul>
                {entry.activities.map((activity, i) => (
                  <p key={i}>
                    {activity.split("\n").map((line, j) => (
                      <React.Fragment key={j}>
                        {line}
                        <br />
                      </React.Fragment>
                    ))}
                  </p>
                ))}
                <p className="text-danger mt-3 fw-bold">{entry.inauspicious}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StandardFormat;